import { render, staticRenderFns } from "./SponsoredBadge.vue?vue&type=template&id=2557b2ab&"
import script from "./SponsoredBadge.vue?vue&type=script&lang=js&"
export * from "./SponsoredBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports